// React
import { useEffect } from "react";

// Redux
import { useSelector } from "react-redux";

// Hooks
import { useLocations } from "@Common/hooks/Location/useLocations.tsx";

// Helpers
import { getTenantParameters } from "@Common/helpers/Tenant";

// Types
import { RootState } from "@/redux/store";

// Constants
const QUERY_IDENTIFIERS = ["usersPageLastUpdate", "positionTable", "allEmployees"];

export const useCacheAndLocations = (clearCache: Function) => {
	const location = useSelector((state: RootState) => state.location.location);
	const { locations, isLoading: loadingLocations } = useLocations(getTenantParameters(location?.locationId ?? "")?.tenant);

	useEffect(() => {
		return () => {
			clearCache(QUERY_IDENTIFIERS);
		};
	}, [location]);

	return { location, locations, loadingLocations };
};
